import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "瓜田热榜", hash: "topics" },
  { label: "观点 PK", hash: "pk" },
  { label: "二创解读", hash: "remix" },
  { label: "吃瓜守则", hash: "rules" },
  { label: "常见问题", hash: "faq" },
];

const tickerItems = [
  "某选秀节目选手临场退赛引发热议",
  "古装剧大结局被指烂尾，观众两极分化",
  "直播掉线三小时，官方暂未回应",
  "综艺「恶剪」争议冲上话题榜",
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-primary-950 text-background-50">
        <div className="flex h-8 items-center overflow-hidden">
          <span className="flex h-full shrink-0 items-center gap-1.5 bg-primary-500 px-3 text-xs font-bold text-background-50 sm:px-4">
            <i className="ri-fire-fill text-sm" aria-hidden="true" />
            热榜
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap pl-6 text-xs text-background-100/90">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span key={`${item}-${index}`} className="flex items-center gap-2">
                  <i className="ri-circle-fill text-[6px] text-accent-400" aria-hidden="true" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-[68px] w-full max-w-[1400px] items-center justify-between px-4 md:px-8">
          <Link to="/" className="flex items-center gap-2.5" aria-label="吃瓜瓜田首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-chat-smile-2-fill text-xl" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                吃瓜瓜田
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
                GUATIAN · 话题社区
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.hash}
                to={`/#${link.hash}`}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/#contact"
              className="hidden items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-add-line text-base" aria-hidden="true" />
              我要发瓜
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-2-line text-2xl"} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-b border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-[1400px] flex-col px-4 py-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.hash}
                to={`/#${link.hash}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3.5 text-base font-medium text-foreground-800"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true" />
              </Link>
            ))}
            <Link
              to="/#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-background-50"
            >
              <i className="ri-add-line text-base" aria-hidden="true" />
              我要发瓜
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}